"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowRoot = void 0;
var _mui = require("@ori-ui/mui");
const ArrowRoot = exports.ArrowRoot = (0, _mui.styled)('div')(({
  theme,
  disabled
}) => ({
  display: 'grid',
  flex: 'none',
  placeItems: 'center',
  position: 'relative',
  width: 48,
  color: theme.palette.text.primary,
  cursor: 'pointer',
  fontSize: '1.6rem',
  WebkitTapHighlightColor: 'transparent',
  opacity: disabled ? 0 : 1
}));
